import type React from 'react';
import styles from './Discount.module.scss';
import Translation from '../../../general/Translation/Translation';
import FormatPrice from '../../../general/Format/FormatPrice';
import type { Price } from '../../../../ssr/src/Outlet/ShoppingCart/ShoppingCartSchema';

interface DiscountProps {
    code: string;
    deleteDiscount: () => void;
    discount: Price;
}

const Discount: React.FC<DiscountProps> = ({ code, deleteDiscount, discount }) => (
    <div className={styles.Discount}>
        <div className={styles.Discount__row}>
            <Translation pageString="account" stringId="discount" />
            <p>
                -
                <FormatPrice price={discount} />
            </p>
        </div>
        <div className={styles.Discount__row}>
            <span className={styles['Discount__discount-code']}>
                (
                {code}
                )
            </span>
            <button
                type='button'
                onClick={deleteDiscount}
                className={styles['Discount__delete-button']}
            >
                <Translation pageString="class.bestelproces" stringId="verwijderen" />
            </button>
        </div>
    </div>
);

export default Discount;
